import { useEffect, useRef } from 'react';
import { bindChannelEvent, unbindChannelEvent } from '../channel-registry';
import type { UseChannelEventOptions } from '../types';
import { useChannel } from './use-channel';

export const useChannelEvent = <TPayload = unknown>({
  channelName,
  eventName,
  listener,
  enabled = true,
  channelType = 'public',
}: UseChannelEventOptions<TPayload>): void => {
  const callbackRef = useRef(listener);
  callbackRef.current = listener;

  const { channel, normalizedChannelName } = useChannel({
    channelName,
    enabled,
    channelType,
  });

  useEffect(() => {
    if (!enabled || !channel || !normalizedChannelName || !eventName) {
      return undefined;
    }

    const token = bindChannelEvent(normalizedChannelName, eventName, payload => {
      callbackRef.current(payload as TPayload);
    });

    if (!token) {
      return undefined;
    }

    return () => {
      unbindChannelEvent(normalizedChannelName, eventName, token);
    };
  }, [enabled, channel, normalizedChannelName, eventName]);
};
